import React, { Component } from "react";
import CEO from "../../Images/ceo.png";
import CeoSign from "../../Images/ceoSign.png";
import "./style.css";

class Mission extends Component {
  render() {
    return (
      <div className="missionConatiner animate__animated animate__fadeIn">
        <div className="missionText animate__animated animate__fadeInDown">
          <div className="tc">
            <img src={CEO} alt="CEO" width="200px" />
          </div>

          <h1 className="tc trainerHeading">Our Mission</h1>
          <p>
            Ali Janjua is the CO-FOUNDER & CEO of WORK a modern-day
            Telemarketing company servicing high profile clients across the
            company’s 4 locations with a headcount of 500+. He is also the
            active CEO of Insured for Life a full-service Insurance agency
            focused on the Final Expense and Medicare space
          </p>
          <p>
            In the early 2000s, after dropping out of school Ali started off in
            the business world as a young 17-year-old customer service rep
            eventually going on to own the company that he started with. Whilst
            still young at age of 25, Ali took over the reins and lead to
            growing the business from a partly $ 1 – 7 million in sales during a
            3 year period
          </p>
          <p>
            Ali is a highly sought after public speaker and influencer
            highlighting what it’s like to be a CEO and public figure in today’s
            world. Ali shares his insight with the world through @askalij
            answering questions and inspiring millions to believe in themselves.
          </p>

          <div className="tr">
            <img src={CeoSign} alt="CEO-Sign" width="150px" />
          </div>
        </div>
      </div>
    );
  }
}
export default Mission;
